import React from 'react';
import { useSelector } from 'react-redux';
import {
  getPendingAccessories,
  getConflictingAccessories,
  getAccessoryPendingRemoval,
  getPendingPackConflicts,
  getPackPendingRemoval,
} from 'src/redux/bike/selectors';
import ConflictingAccessories from 'components/_steps/ConflictingAccessories/ConflictingAccessories';
import RequiredAccessories from 'components/_steps/RequiredAccessories/RequiredAccessories';
import RemoveRequiredAccessories from 'components/_steps/RemoveRequiredAccessories/RemoveRequiredAccessories';
import PackAccessoryConflicts from 'components/_steps/PackAccessoryConflicts/PackAccessoryConflicts';
import AccessoryPackConflicts from 'components/_steps/AccessoryPackConflicts/AccessoryPackConflicts';
import RemovePack from 'components/_steps/RemovePack/RemovePack';

const PendingAccessoriesSwitch = () => {
  const pendingAccessories = useSelector(getPendingAccessories);
  const conflictingAccessories = useSelector(getConflictingAccessories);
  const accessoryPendingRemoval = useSelector(getAccessoryPendingRemoval);
  const pendingPackConflicts = useSelector(getPendingPackConflicts);
  const packPendingRemoval = useSelector(getPackPendingRemoval);

  if (packPendingRemoval && pendingAccessories.length) {
    return <AccessoryPackConflicts />;
  }

  if (packPendingRemoval) {
    return <RemovePack />;
  }

  if (pendingPackConflicts.length) {
    return <PackAccessoryConflicts />;
  }

  if (accessoryPendingRemoval) {
    return <RemoveRequiredAccessories />;
  }

  if (!pendingAccessories.length) {
    return null;
  }

  return conflictingAccessories.length ? <ConflictingAccessories /> : <RequiredAccessories />;
};

export default PendingAccessoriesSwitch;
